import { Component, ElementRef, HostListener, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-edit-image-dialog',
  templateUrl: './edit-image-dialog.component.html',
  styleUrls: ['./edit-image-dialog.component.css']
})
export class EditImageDialogComponent implements OnInit {

  photo: string;


  selectedTool = 1;

  // Selected colour
  selectedColour = 'deepskyblue';

  // Is the mouse currently clicked down over the canvas.
  isMouseClicked: boolean;

  // Is the mouse currently over the canvas.
  isMouseOverCanvas: boolean;

  // Previous mouse coordinates.
  previousX: number;
  previousY: number;

  // Undo action.
  undoAction: string;

  // Track if the user has the mouse down and is currently drawing.
  startedDrawingWithPencil = false;
  @Input() id: number;
  @Input() photoType: string;

  @ViewChild('photoCanvas') photoCanvas: ElementRef;
  private context: CanvasRenderingContext2D;

  @HostListener('document: mousemove', ['$event'])
  onMouseMove(e) {
      if (this.isMouseOverCanvas) {
          this.drawWithTool(e);
      }
  }

  constructor(public dialogRef:MatDialogRef<EditImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _sanitizer: DomSanitizer
    
   ) { }

 // QuestionImage=this.data.QuestionImage
 // QuestionId=this.data.QuestionId

  ngOnInit() {
  }
  DialogClose(){
    this.dialogRef.close(false)
  }

  // sanitize(image: string) {
  //   console.log(Image)
  //   return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;png;base64,${image}`); 
  // }
 
  ngAfterViewInit() {
    if (this.data != null) {
      this.photo = this.data.QuestionImage;
      if (this.data.photoWithExt != null) {
        this.photo = this.data.photoWithExt;
      }

      this.context = (this.photoCanvas.nativeElement as HTMLCanvasElement).getContext('2d');
      this.draw();
    }
}

private draw() {

  const canvas = this.photoCanvas.nativeElement as HTMLCanvasElement;
  const ctx = this.context;

  const img = new Image();
  img.onload = function () {
      canvas.setAttribute('width', img.width.toString());
      canvas.setAttribute('height', img.height.toString());

      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  };
  if (this.data.photoWithExt == null) {
     img.src = 'data:image/png;base64,' + this.photo;
  }     else {
      img.src = this.photo;
  }

}
mouseEnterCanvas(evt) {
  this.isMouseOverCanvas = true;
}

mouseLeaveCanvas(evt) {
  this.isMouseOverCanvas = false;
}

mouseDownOverCanvas(evt) {
  this.isMouseClicked = true;
}

mouseUpOverCanvas(evt) {
  this.isMouseClicked = false;
}

resetPreviousCoordinates() {
  this.previousX = 0;
  this.previousY = 0;
}
drawWithTool(evt) {
  const ctx = this.context;
  const canvas = this.photoCanvas.nativeElement as HTMLCanvasElement;
  const rect = canvas.getBoundingClientRect;

  const mouseX = evt.clientX - canvas.parentElement.offsetLeft + canvas.parentElement.scrollLeft;
  const mouseY = evt.clientY - canvas.parentElement.offsetTop + canvas.parentElement.scrollTop;

  // Freehand drawing using the Pencil tool.
  if (this.selectedTool === 1) {

      if ((this.isMouseOverCanvas) && (this.isMouseClicked)) {

          if (!this.startedDrawingWithPencil) {
              this.storeLastImageAction();
              this.startedDrawingWithPencil = true;
          }

          if ((this.previousX > 0) && (this.previousY > 0)) {
              ctx.beginPath();
              ctx.moveTo(this.previousX, this.previousY);
              ctx.lineTo(mouseX, mouseY);
              ctx.lineWidth = 4;
              ctx.lineJoin = ctx.lineCap = 'round';
              ctx.strokeStyle = this.selectedColour;
              ctx.stroke();
          }

          this.previousX = mouseX;
          this.previousY = mouseY;
      }           else {
          this.startedDrawingWithPencil = false;
          this.resetPreviousCoordinates();
      }
  } else if (this.selectedTool === 2) {
      // Draw an arrow, using the mouse click and release points to define the length.
      if ((this.isMouseOverCanvas) && (this.isMouseClicked)) {
          if ((this.previousX > 0) && (this.previousY > 0)) {
              // Do nothing till the mouse is released.
          }             else {
              this.previousX = mouseX;
              this.previousY = mouseY;
          }
      }           else if ((this.isMouseOverCanvas) && !(this.isMouseClicked)) {
          if ((this.previousX > 0) && (this.previousY > 0)) {
              this.storeLastImageAction();

              // Line
              ctx.beginPath();
              ctx.moveTo(this.previousX, this.previousY);
              ctx.lineTo(mouseX, mouseY);
              ctx.lineWidth = 3;
              ctx.lineJoin = ctx.lineCap = 'round';
              ctx.strokeStyle = this.selectedColour;
              ctx.stroke();

              // Arrowhead
              const xDiff = mouseX - this.previousX;
              const yDiff = mouseY - this.previousY;
              const angle = Math.atan2(yDiff, xDiff);
              const arrowSize = 20;

              ctx.beginPath();
              ctx.moveTo(mouseX, mouseY);
              ctx.lineTo(mouseX - arrowSize * Math.cos(angle - Math.PI / 6), mouseY - arrowSize * Math.sin(angle - Math.PI / 6));
              ctx.lineTo(mouseX - arrowSize * Math.cos(angle + Math.PI / 6), mouseY - arrowSize * Math.sin(angle + Math.PI / 6));
              ctx.lineTo(mouseX, mouseY);

              ctx.strokeStyle = this.selectedColour;
              ctx.lineWidth = 2;
              ctx.lineJoin = ctx.lineCap = 'round';
              ctx.stroke();
              ctx.fillStyle = this.selectedColour;
              ctx.fill();

              this.resetPreviousCoordinates();
          }    else {
              // Do nothing
              this.resetPreviousCoordinates();
          }
      }
  }  else if (this.selectedTool === 3) {
// Draw a circle, using the mouse click and release points to define the diameter.
      if ((this.isMouseOverCanvas) && (this.isMouseClicked)) {
          if ((this.previousX > 0) && (this.previousY > 0)) {
              // Do nothing till the mouse is released.
          }               else {
              this.previousX = mouseX;
              this.previousY = mouseY;
          }
      }          else if ((this.isMouseOverCanvas) && !(this.isMouseClicked)) {
          if ((this.previousX > 0) && (this.previousY > 0)) {
              const xDifference = mouseX - this.previousX;
              const yDifference = mouseY - this.previousY;
              const zLength = Math.sqrt((xDifference * xDifference) + (yDifference * yDifference));

              this.storeLastImageAction();

              ctx.beginPath();
              ctx.arc(this.previousX + xDifference / 2, this.previousY + yDifference / 2, zLength / 2, 0, 2 * Math.PI, true);
              ctx.lineWidth = 4;
              ctx.strokeStyle = this.selectedColour;
              ctx.stroke();

              this.resetPreviousCoordinates();
          }      else {
              // Do nothing
              this.resetPreviousCoordinates();
          }
      }
  }    else if (this.selectedTool === 4) {
// Draw a line, using the mouse click and release points to define the length.
      if ((this.isMouseOverCanvas) && (this.isMouseClicked)) {
          if ((this.previousX > 0) && (this.previousY > 0)) {
              // Do nothing till the mouse is released.
          }            else {
              this.previousX = mouseX;
              this.previousY = mouseY;
          }
      } else if ((this.isMouseOverCanvas) && !(this.isMouseClicked)) {
          if ((this.previousX > 0) && (this.previousY > 0)) {
              this.storeLastImageAction();

              ctx.beginPath();
              ctx.moveTo(this.previousX, this.previousY);
              ctx.lineTo(mouseX, mouseY);
              ctx.lineWidth = 4;
              ctx.strokeStyle = this.selectedColour;
              ctx.stroke();

              this.resetPreviousCoordinates();
          }   else {
              // Do nothing
              this.resetPreviousCoordinates();
          }
      }
  }

}
displayTextInput($event) {
  if (this.selectedTool === 5) {
      if (this.isMouseOverCanvas) {
          this.storeLastImageAction();

          const ctx = this.context;
          const canvas = this.photoCanvas.nativeElement as HTMLCanvasElement;

          const mouseX = $event.clientX - canvas.parentElement.offsetLeft + canvas.parentElement.scrollLeft;
          const mouseY = $event.clientY - canvas.parentElement.offsetTop + canvas.parentElement.scrollTop;

          const textInput = document.getElementById('textInput');
          textInput.style.left = mouseX.toString() + 'px';
          textInput.style.top = mouseY.toString() + 'px';
          textInput.style.display = '';
          textInput.focus();
      }
  }
}

// Draw text at the user selected location on the canvas.
enterText($event) {
  const ctx = this.context;
  const textInput = $event.target;

  if ($event.keyCode === 13) {
      ctx.font = '20px Roboto';
      ctx.fillStyle = this.selectedColour;
      ctx.fillText(textInput.value, parseInt((textInput.style.left).replace('px', '')),
          parseInt((textInput.style.top).replace('px', '')));
      textInput.style.display = 'none';
      textInput.value = '';
  }
}

selectTool(tool: string) {
  if (tool === 'Pencil') {
      this.selectedTool = 1;
  } else if (tool === 'Arrow') {
      this.selectedTool = 2;
  } else if (tool === 'Circle') {
      this.selectedTool = 3;
  } else if (tool === 'Line') {
      this.selectedTool = 4;
  } else if (tool === 'Text') {
      this.selectedTool = 5;
  }
}
selectColour($event, colour: string) {
  this.selectedColour = colour;
}

rotatePhoto(direction: string) {
  const canvas = this.photoCanvas.nativeElement as HTMLCanvasElement;
  const ctx = this.context;

  const x = canvas.width / 2;
  const y = canvas.height / 2;

  const rotatedImage = new Image();
  rotatedImage.src = canvas.toDataURL();
  rotatedImage.onload = function () {

      const w = rotatedImage.width;
      const h = rotatedImage.height;

      ctx.save();
      ctx.translate(x, y);

      canvas.setAttribute('width', h.toString());
      canvas.setAttribute('height', w.toString());

      if (direction === 'Left') {

          ctx.rotate(-90 * Math.PI / 180);
          ctx.drawImage(rotatedImage, -w, 0);
          ctx.rotate(90 * Math.PI / 180);

      } else if (direction === 'Right') {

          ctx.rotate(90 * Math.PI / 180);
          ctx.drawImage(rotatedImage, 0, -h);
          ctx.rotate(-90 * Math.PI / 180);

      }

      ctx.restore();
  };

}
storeLastImageAction() {
  const canvas = this.photoCanvas.nativeElement as HTMLCanvasElement;
  this.undoAction = canvas.toDataURL();
}

undoLastAction() {
  const canvas = this.photoCanvas.nativeElement as HTMLCanvasElement;
  const ctx = this.context;

  const restoreImage = new Image();
  restoreImage.src = this.undoAction;
  restoreImage.onload = function () {
      canvas.setAttribute('width', restoreImage.width.toString());
      canvas.setAttribute('height', restoreImage.height.toString());

      ctx.drawImage(restoreImage, 0, 0, canvas.width, canvas.height);
  };
}

EditQuestionImages:number[]=[]
onCloseClick(save: boolean): void {
  if (save) {

    
      const canvas = this.photoCanvas.nativeElement as HTMLCanvasElement;
      const rotatedImage = new Image();
      rotatedImage.src = canvas.toDataURL();
      this.dialogRef.close({ photo: (rotatedImage.src).split(',')[1] });
  } else {
      this.dialogRef.close();
  }

}




}
